import { useState, useRef } from "react";

export const usePieChart = (title) => {
    const chartRef = useRef(null);

    const [options, setOptions] = useState({
        chart: {
            type: "pie",
            events: {
                load: function () {
                    chartRef.current = this;
                },
            },
        },
        title: {
            text: "",
            align: "center",
        },
        tooltip: {
            headerFormat: "",
            pointFormat: "{point.name}: <b>{point.percentage:.1f}%</b>",
        },
        accessibility: {
            point: {
                valueSuffix: "%",
            },
        },
        lang: {
            viewFullscreen: "Ver en pantalla completa",
            loading: "Cargando...",
            noData: "No hay datos para mostrar",
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen"],
                },
            },
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: "pointer",
                dataLabels: {
                    enabled: true,
                    format: "<b>{point.name}</b>: {point.percentage:.1f}%",
                },
            },
        },
        series: [
            {
                colorByPoint: true,
                data: [],
            },
        ],
        credits: { enabled: false },
    });

    const showLoading = () => chartRef.current?.showLoading();
    const hideLoading = () => chartRef.current?.hideLoading();

    const onChartReady = (chartInstance) => {
        chartRef.current = chartInstance;
    };

    return {
        options,
        setOptions,
        showLoading,
        hideLoading,
        onChartReady,
    };
};
